import { IBundleProduct, IManhattanBundle } from '../../../entities/manhattan/bundle/types';
import BundleProductService from '../../../services/BundleProductService';
import BusinessRuleFacade from '../../../rules/manhattan/BundleProductBusinessRuleFacade';
import { ProductTypes } from '../../../constants/ProductTypes';
import {
  ISelectedProductWithPurchaseType,
  ISelectedProductStb,
  ISelectedProductAdditionalItem,
} from '../../../entities/manhattan/submit/types';
import { BundleProductPricesTypes } from '../../../constants/BundleProductPricesTypes';
import SelectedFtthProduct from '../../../entities/manhattan/submit/SelectedFtthProduct';
import { isCustomerTypeOptionExisting } from '../../../utilites/util';

export default class BundleDataFtthSelectedProductsFactory {

  private readonly bundle: any;
  private readonly params?: any;
  private readonly bundleProductService: BundleProductService;

  constructor(bundle: IManhattanBundle, params?: any) {
    this.bundle = bundle;
    this.params = params;
    this.bundleProductService = BundleProductService.getInstance();
  }

  getFeasibilityData(params: any) {
    return {
      city: params.city,
      municipality: params.municipality,
      neighborhood: params.neighborhood,
      street: params.street,
      addressType: params.addressType,
      apartmentNumber: params.apartmentNumber,
      buildingEntriesNumber: params.buildingEntriesNumber,
      buildingNumber: params.buildingNumber,
      buildingSubNumber: params.buildingSubNumber,
    };
  }

  getCustomerData(params: any) {
    return {
      firstName: params.firstName ? params.firstName : null,
      lastName: params.lastName ? params.lastName : null,
      phone: params.phone ? params.phone : null,
      email: params.email ? params.email : null,
    };
  }

  public getSelectedProducts(bundle: IManhattanBundle) {
    const businessRuleFacade = BusinessRuleFacade.getInstance();
    const additionalItems: ISelectedProductAdditionalItem[] = [];
    let feasibilityData = null;
    let customerData = null;
    const existingCustomer = isCustomerTypeOptionExisting();
    const feasibilityDataParams = this.getFeasibilityData(this.params);
    const customerDataParams = this.getCustomerData(this.params);

    if (customerDataParams?.email || customerDataParams?.phone || customerDataParams?.firstName) {
      customerData = customerDataParams;
    }

    if (feasibilityDataParams.city || feasibilityDataParams?.municipality || feasibilityDataParams?.street) {
      feasibilityData = feasibilityDataParams;
    }

    const stb: ISelectedProductStb = {
      id: 0,
      quantity: 0,
    };

    const fix: ISelectedProductWithPurchaseType = {
      id: 0,
      quantity: 0,
      purchaseType: '',
    };

    bundle.bundleProducts.forEach((bundleProduct: IBundleProduct) => {
      businessRuleFacade.init(bundleProduct);
      switch (bundleProduct.product.productLine.productLine) {
      case ProductTypes.STB:
        stb.id = bundleProduct.product.id;
        stb.quantity = this.bundleProductService.getBundleProductMinimumDevices();
        break;
      case ProductTypes.CORDLESS_PHONE:
        fix.id = bundleProduct.product.id;
        fix.quantity = this.bundleProductService.getBundleProductMinimumDevices();
        //default purchase type if there is preselected product
        fix.purchaseType = fix.quantity !== 0 ? BundleProductPricesTypes.CREDIT_PRICE24 : '';
        break;
      }
    });

    return new SelectedFtthProduct(
      bundle.id,
      bundle.productLine.productLine,
      stb,
      fix,
      additionalItems,
      feasibilityData,
      customerData,
      existingCustomer
    );
  }

  public create() {
    return this.getSelectedProducts(this.bundle);
  }

}
